import _ from 'lodash';

const constants = {
    endpoints: {
        lead: '/ajax/activityloggingapi/1.0/lead',
        impression: '/ajax/a773a9c189a3ff4/1.0/impression',
        clickthru: '/ajax/a773a9c189a3ff4/1.0/clickthru'
    },
    pageName: {
        vdp: 2104,
        os: 2424,
        testDrive: {
            loan: 2425,
            lease: 2428,
            cash: 2431
        },
        phoneCall: {
            loan: 2426,
            lease: 2429,
            cash: 2432
        },
        askQuestion: {
            loan: 2427,
            lease: 2430,
            cash: 2433
        }
    },
    stockType: {
        used: 93, //OR CPO
        new: 94
    }
};

export function getPageNameId(pageName, payment) {
    if (payment) {
        return _.get(constants.pageName, `${pageName}.${payment}`, 0);
    }
    return _.get(constants.pageName, `${pageName}`, 0);
}

function pageStateExists() {
    return !!(window.CARS && window.CARS.PageState && window.CARS.digitalData);
}

function push(key, value, emit) {
    if (pageStateExists()) {
        window.CARS.PageState.push(key, value, emit);
    }
}

function sendAlsTracking(alsParams, apiUrl) {
    let xhr = new XMLHttpRequest();
    xhr.open('POST', apiUrl, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify(alsParams));
}

function _buildAlsParams(logType, pageFromId, pageToId) {
    let alsParams = {
        sellerId: _.get(window, 'listing.sellerDto.sellerId', '0'),
        makeId: _.get(window, 'listing.listingDetailDto.makeId', '0'),
        modelId: _.get(window, 'listing.listingDetailDto.modelId', '0'),
        listingId: _.get(window, 'listing.listingDetailDto.listingId', '0'),
        modelYearId: _.get(window, 'listing.listingDetailDto.modelYearId', '0'),
        stockTypeCode: _.get(window, 'listing.listingDetailDto.stockTypeCode', '0'),
        trimId: _.get(window, 'listing.listingDetailDto.trimId', '0'),
        latitude: false,
        longitude: false,
        publicConsumerId: null,
        publicDeviceId: null,
        affiliateAgentId: '0',
        localOfferId: '0',
        primaryFeedSourceId: '0',
    };
    if (window._satellite) {
        alsParams.latitude = window._satellite.getVar('latitude');
        alsParams.longitude = window._satellite.getVar('longitude');
        alsParams.publicConsumerId = window._satellite.getVar('pcid');
        alsParams.publicDeviceId = window._satellite.getVar('pdid');
    }
    if (pageFromId !== 0) {
        alsParams.pageFromId = pageFromId;
    }
    if (pageToId !== 0) {
        alsParams.pageToId = pageToId;
    }
    if (logType == 'lead') {
        alsParams.leadTypeId = alsParams.stockTypeCode.toLowerCase() === 'new' ? constants.stockType.new : constants.stockType.used;
    }
    return alsParams;
}

export function logAlsLead (pageFromId = 0, pageToId = 0){
    const alsParams = _buildAlsParams('lead', pageFromId, pageToId);
    const apiUrl = constants.endpoints.lead;
    sendAlsTracking(alsParams, apiUrl);
}

export function logAlsImpression(pageFromId = 0, pageToId = 0) {
    const alsParams = _buildAlsParams('impression', pageFromId, pageToId);
    const apiUrl = constants.endpoints.impression;
    sendAlsTracking(alsParams, apiUrl);
}

export function logAlsClickthru(pageFromId = 0, pageToId = 0) {
    const alsParams = _buildAlsParams('clickthru', pageFromId, pageToId);
    const apiUrl = constants.endpoints.clickthru;
    sendAlsTracking(alsParams, apiUrl);
}

export function assignPageName(name) {
    if (pageStateExists()) {
        let pageObject = window.CARS.PageState.get('page');
        pageObject.pageInfo.pageName = name;
    }
}

export function pageDataReady() {
    push("event", { eventName: 'page-data-ready' }, true);
}

export function assignPageNameAndFire(name) {
    assignPageName(name);
    pageDataReady();
}

export function assignModalPageNameAndFire(name) {
    if (pageStateExists()) {
        let stack = window.CARS.PageState.get('page.pageInfo.pageName');
        if (typeof stack != "string" && stack.length > 1) {
            stack = stack[0].concat(name);
            window.CARS.PageState.set('page.pageInfo.pageName', stack, false);
        } else {
            window.CARS.PageState.push('page.pageInfo.pageName', name, false);
        }
    }
    pageDataReady();
}

export function popPageName() {
    if (pageStateExists()) {
        window.CARS.PageState.pop('page.pageInfo.pageName');
    }
}

/*eslint-disable camelcase*/
export function adobeLinkTracking(pageNameInput,linkNameInput){
    if (window.s_dtm) {
        window.s_dtm.linkTrackVars = 'prop48,prop49,prop50';
        var pageLink = pageNameInput + '|' + linkNameInput;
        window.s_dtm.prop48 = pageLink;
        window.s_dtm.prop49 = linkNameInput;
        window.s_dtm.prop50 = pageNameInput;
        window.s_dtm.tl(true,'o',pageLink);
    }
}

/*eslint-disable camelcase*/
export function adobePageViewTracking(pageNameInput,linkNameInput,currentPageName){
    if (window.s_dtm) {
        window.s_dtm.linkTrackVars = 'prop48,prop49,prop50';
        var pageLink = pageNameInput + '|' + linkNameInput;
        window.s_dtm.prop48 = pageLink;
        window.s_dtm.prop49 = linkNameInput;
        window.s_dtm.prop50 = pageNameInput;
        window.s_dtm.pageName = currentPageName;
        window.s_dtm.eVar10 = currentPageName;
        window.s_dtm.t();
    }

    if (window._satellite) {
        window._satellite.track('PageViewCall');
    }
}

export default {
    getPageNameId,
    assignPageName,
    pageDataReady,
    assignPageNameAndFire,
    logAlsImpression,
    logAlsLead,
    logAlsClickthru,
    adobeLinkTracking,
    adobePageViewTracking
};